/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import type Form from '../../../../../../forms/_.extend';

type TypeProps = {
  product: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveProductForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;
    const product: Object = this.props.product;

    const productDetails: Array<Array> = [
      [t('general:manufacturers.labels.name'), product.manufacturer_name],
      [t('general:model'), product.model],
      [t('general:products.labels.base_model'), product.base_model],
      [],
      [t('general:assets.abbrs.number_using_model'), product.assets_count],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:products.labels.details')}
          >
            <ActionDrawerTable data={productDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={t('general:products.reasons.why_unarchive')}>
            <ElectroTextField
              field={form.$('unarchiveProductForm.reason')}
              props={{
                multiline: true,
                rows: 3,
              }}
              margin="none"
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.unarchive')} />
      </React.Fragment>
    );
  }
}
